exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/header/navigationbar/delete-client-transaction/confirm-delete-transaction/confirm-delete-transaction.component.css
// module id = 2010
// module chunks = 0